<template>
	<vx-card>
		<div class="vx-col">
			<div class="vx-row">
				<div class="vx-col sm:w-1/2 w-full mb-2">
					<h3>Ajouter une prestation</h3>
				</div>
				<div class="vx-col sm:w-1/2 w-full mb-2">
					<vs-button
						class="float-right"
						radius
						color="primary"
						type="filled"
						icon-pack="feather"
						icon="icon-x"
						@click="returnPrevRoute"
					></vs-button>
				</div>
			</div>
			<div class="vx-row mt-4">
				<div class="vx-col w-full">
					<vs-select
						autocomplete
						v-model="product.category"
						class="w-full select-large mt-4"
						placeholder="Catégorie"
					>
						<vs-select-item
							:key="index"
							:value="item.id"
							:text="item.name"
							v-for="(item, index) in categoryOptions"
							class="w-full"
						/>
					</vs-select>
				</div>
				<div class="vx-col w-full">
					<vs-select
						autocomplete
						v-model="product.sub_category"
						class="w-full select-large mt-4"
						placeholder="Sous-catégorie"
					>
						<vs-select-item
							:key="index"
							:value="item.id"
							:text="item.name"
							v-for="(item, index) in subCategoriesOptions"
							class="w-full"
						/>
					</vs-select>
				</div>
				<div class="vx-col w-full">
					<vs-select
						autocomplete
						v-model="product.deliverable"
						class="w-full select-large mt-4"
						placeholder="Produit créé pour Commande?"
					>
						<vs-select-item
							:key="index"
							:value="item.value"
							:text="'Commande: ' + item.text"
							v-for="(item, index) in categoriesOptions"
							class="w-full"
						/>
					</vs-select>
				</div>
				<div class="vx-col w-full">
					<vs-select
						autocomplete
						v-model="product.missionable"
						class="w-full select-large mt-4"
						placeholder="Produit créé pour Prestation?"
					>
						<vs-select-item
							:key="index"
							:value="item.value"
							:text="'Prestation: ' + item.text"
							v-for="(item, index) in categoriesOptions"
							class="w-full"
						/>
					</vs-select>
				</div>
			</div>
			<div class="vx-row mt-4">
				<div class="vx-col w-full">
					<vs-input
						v-model="product.perform"
						placeholder="Prestation"
						class="w-full"
						:style="styleValidator('perform')"
					/>
					<vx-tooltip
						v-if="validators['perform'].errText !== ''"
						:text="errText('perform')"
						class="ml-3"
					>
						<vs-icon icon="error" size="medium" style="color: red"></vs-icon>
					</vx-tooltip>
				</div>
			</div>
			<div class="vx-col w-full">
				<vs-select
					autocomplete
					v-model="product.language_id"
					class="w-full select-large mt-4"
					placeholder="Langue"
				>
					<vs-select-item
						:key="index"
						:value="item.id"
						:text="item.name"
						v-for="(item, index) in languages"
						class="w-full"
					/>
				</vs-select>
			</div>
			<div class="vx-col w-full">
				<vs-select
					autocomplete
					v-model="product.currency"
					class="w-full select-large mt-4"
					placeholder="Devise"
				>
					<vs-select-item
						:key="index"
						:value="item.sub_name"
						:text="item.name"
						v-for="(item, index) in currencies"
						class="w-full"
					/>
				</vs-select>
			</div>
			<div class="vx-row mt-4">
				<div class="vx-col w-full mb-2">
					<label for="" class="vs-select--label">Description courte</label>
					<vs-textarea
						v-model="product.shortDescription"
						class="mb-0"
						rows="1"
						:style="styleValidator('shortDescription')"
					/>
					<vx-tooltip
						v-if="validators['shortDescription'].errText !== ''"
						:text="errText('shortDescription')"
						class="ml-3"
					>
						<vs-icon icon="error" size="medium" style="color: red"></vs-icon>
					</vx-tooltip>
				</div>
			</div>
			<div class="vx-row mt-2">
				<div class="vx-col w-full mb-2">
					<label for="" class="vs-select--label">Description longue</label>
					<vs-textarea
						v-model="product.longDescription"
						class="mb-0"
						rows="7"
						:style="styleValidator('longDescription')"
					/>
					<vx-tooltip
						v-if="validators['longDescription'].errText !== ''"
						:text="errText('longDescription')"
						class="ml-3"
					>
						<vs-icon icon="error" size="medium" style="color: red"></vs-icon>
					</vx-tooltip>
				</div>
			</div>
			<!-- <div class="vx-row mt-2">
        <div class="vx-col w-full ">
          <vs-checkbox class="inline-flex mt-4" v-model="product.isNetlink"
            >Est un produit de type Netlink</vs-checkbox
          >
        </div>
      </div>
      <div class="vx-row mt-3 right_element"> -->
			<div class="vx-col">
				<vs-button
					color="warning"
					type="border"
					class="mb-2 mr-3"
					@click="resetForm(product)"
					>Réinitialiser</vs-button
				>
				<vs-button class="mb-2" @click="formSubmitted">Ajouter</vs-button>
			</div>
		</div>
		<!-- </div> -->
	</vx-card>
</template>

<script>
import Product from "@/entities/Product";
import utilsMixin from "@/mixins/utilsMixin";
import store from "@/store/store";

export default {
	name: "ProductForm",
	props: {
		chartParams: Object,
		isPercent: Boolean,
	},
	mixins: [utilsMixin],
	computed: {
		products: () => {
			return store.state.products;
		},
		categoryOptions: () => {
			return store.state.products_categories;
		},
		subCategoriesOptions: () => {
			return store.state.products_sub_categories;
		},
	},
	data() {
		return {
			categoriesOptions: [
				{ text: "Non", value: 0 },
				{ text: "Oui", value: 1 },
			],
			currencies: [],
			languages: [],
			// PRODUCT OBJECT
			product: Product.getFormFields(),
			apiUrl: this.$store.state.backendApiUrl,
			// FORM SELECT OPTIONS
			validators: {
				perform: {
					errText: "",
				},
				longDescription: {
					errText: "",
				},
				shortDescription: {
					errText: "",
				},
			},
			check: true,
		};
	},
	created() {
		this.getAllProducts();
		this.getAllProductsCategories();
		this.getAllProductsSubCategories();
		this.getAllCurrencies();
		this.getAllLanguages();
	},
	methods: {
		async getAllLanguages() {
			this.$http.get("/others/languages").then((res) => {
				this.languages = res.data;
			});
		},
		getAllCurrencies() {
			this.$http.get("/product/currencies/all").then((res) => {
				this.currencies = res.data;
			});
		},
		getAllProducts() {
			if (this.store) this.store.dispatch("getAllProducts");
			else store.dispatch("getAllProducts");
		},

		getAllProductsCategories() {
			this.$store.dispatch("getAllProductsCategories");
		},

		getAllProductsSubCategories() {
			this.$store.dispatch("getAllProductsSubCategories");
		},
		errText(name) {
			if (this.validators[name].errText !== "") {
				return this.validators[name].errText;
			}
		},
		styleValidator(name) {
			if (this.validators[name].errText !== "") {
				return "border: 1px solid red !important; border-radius: 5px;";
			} else if (this.validators[name].errText == "") {
				return "border: 1px solid green !important; border-radius: 5px;";
			} else {
				return "border: none !important; border-radius: none;";
			}
		},
		/**
		 * Send the data to tha API to create the new user
		 */
		formSubmitted() {
			this.check = true;
			let fields = ["perform", "longDescription", "shortDescription"];
			for (let i = 0; i < 3; i++) {
				if (this.product[fields[i]] == "" || this.product[fields[i]] == null) {
					this.validators[fields[i]].errText = "Ce champ ne peut être vide.";
					this.check = false;
				} else {
					this.validators[fields[i]].errText = "";
				}
			}
			this.$forceUpdate();

			if (this.check == false) {
				this.$vs.notify({
					title: "Echec",
					text: "Veuillez remplir tous les champs.",
				});
				return;
			}
			this.$http
				.post(this.apiUrl + "product/new", {
					category: this.product.category,
					sub_category: this.product.sub_category,
					perform: this.product.perform,
					short_description: this.product.shortDescription,
					long_description: this.product.longDescription,
					is_netlink: this.product.isNetlink,
					missionable: this.product.missionable,
					deliverable: this.product.deliverable,
					currency: this.product.currency,
					language_id: this.product.language_id,
				})
				.then((res) => {
					//console.log(res);
					// Send a success notification to the user
					this.$vs.notify({
						title: "Succès",
						text: "Prestation ajoutée avec succès.",
					});
					this.$store.dispatch("getAllProducts");
					// Send the user to the previous route
					this.$router.go(-1);
				})
				.catch((err) => {
					//console.log(err);
					this.$vs.notify({
						title: "Echec",
						text: "La prestation n'a pas été ajoutée.",
					});
				});
		},

		/**
		 * Redirect to the previous page
		 */
		returnPrevRoute() {
			this.$router.go(-1);
		},
	},
};
</script>

<style scoped>
.role_selector_container {
	justify-content: space-between;
	width: 40%;
}

.role_container {
	justify-content: center;
}

.space_div {
	margin: 5px;
}

.right_element {
	justify-content: flex-end;
}

.bottom {
	align-self: flex-end;
}

.center {
	align-self: center;
}
</style>
